import React, { Component } from "react";
import { useMediaQuery } from "react-responsive";

import NotSupport from "../other/notSupport";
import ShareMobile from "./ShareMobile";
import SharePc from "./SharePc";

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1367 });
  return isDesktop ? children : null;
};
const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1366 });
  return isTablet ? children : null;
};
const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  return isMobile ? children : null;
};
const Portrait = ({ children }) => {
  const isPortrait = useMediaQuery({ orientation: "portrait" });
  return isPortrait ? children : null;
};
const Landscape = ({ children }) => {
  const isLandscape = useMediaQuery({ orientation: "landscape" });
  return isLandscape ? children : null;
};

export default class Share extends Component {
  render() {
    return (
      <div>
        <Desktop>
          <Portrait>
            <NotSupport />
          </Portrait>
          <Landscape>
            <SharePc
              currentBatten={this.props.match.params.idBatten}
              currentFloor={this.props.match.params.idFloor}
            />
          </Landscape>
        </Desktop>
        <Tablet>
          <ShareMobile
            currentBatten={this.props.match.params.idBatten}
            currentFloor={this.props.match.params.idFloor}
          />
        </Tablet>
        <Mobile>
          <ShareMobile
            currentBatten={this.props.match.params.idBatten}
            currentFloor={this.props.match.params.idFloor}
          />
        </Mobile>
      </div>
    );
  }
}
